import { gql } from '@apollo/client'

const CreateCheckoutSession = gql`
    mutation CreateCheckoutSession($cancelUrl: String!, $successUrl: String!) {
        createCheckoutSession(cancelUrl: $cancelUrl, successUrl: $successUrl)
    }
`

export default CreateCheckoutSession

